import React from 'react';
import PropTypes from 'prop-types';
import { t } from '@app/dev/helpers/translator';

import tournamentLeaderboardIcon from '../../../../images/tournament-leaderboard-icon.png';

const TournamentLeaderboard = ({ tournament }) => (
    <div className="tournament-stats tournament-leaderboard">
        <div className="stats-top">
            <img src={tournamentLeaderboardIcon} />
            <h2>{t('Prizes')}</h2>
        </div>

        <div className="stats-content">
            <div className="stats-content-inner">
                {tournament.TopPlayerList?.TopPlayerList?.map(item => <p key={item.PlayerId}>
                    {item.Place} {item.PlayerId}

                    <span className="stats-amount">{item.Amount}</span>
                    </p>)}
            </div>
        </div>
    </div>
);

TournamentLeaderboard.propTypes = {
    tournament: PropTypes.object.isRequired,
};

export default TournamentLeaderboard;